// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"b38bb976","467":"848b7921","564":"ce9feeb0","655":"4f0d39c8","956":"b209cb32"}[chunkId] + ".chunk.css";
};